import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHeadphonesHead = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.05252 3.52299C7.4995 3.92094 6.10039 4.77289 5.03397 5.96996C3.96755 7.16703 3.28225 8.65488 3.06563 10.2434C2.84902 11.8319 3.11093 13.4489 3.8179 14.8878C4.52487 16.3267 5.64479 17.5221 7.03456 18.3214V22.0882"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.70728 11.3275C7.70728 11.7692 7.79427 12.2065 7.96329 12.6145C8.13231 13.0226 8.38004 13.3934 8.69235 13.7057C9.00466 14.018 9.37542 14.2657 9.78347 14.4347C10.1915 14.6038 10.6289 14.6907 11.0705 14.6907C11.5122 14.6907 11.9496 14.6038 12.3576 14.4347C12.7657 14.2657 13.1364 14.018 13.4487 13.7057C13.761 13.3934 14.0088 13.0226 14.1778 12.6145C14.3468 12.2065 14.4338 11.7692 14.4338 11.3275C14.4338 10.8858 14.3468 10.4485 14.1778 10.0404C14.0088 9.63237 13.761 9.2616 13.4487 8.9493C13.1364 8.63699 12.7657 8.38925 12.3576 8.22023C11.9496 8.05121 11.5122 7.96422 11.0705 7.96422C10.6289 7.96422 10.1915 8.05121 9.78347 8.22023C9.37542 8.38925 9.00466 8.63699 8.69235 8.9493C8.38004 9.2616 8.13231 9.63237 7.96329 10.0404C7.79427 10.4485 7.70728 10.8858 7.70728 11.3275V11.3275Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0884 8.63687V2.58299C13.0884 2.40459 13.0175 2.2335 12.8914 2.10735C12.7652 1.98121 12.5942 1.91034 12.4158 1.91034H9.72514C9.54674 1.91034 9.37565 1.98121 9.24951 2.10735C9.12336 2.2335 9.05249 2.40459 9.05249 2.58299V8.63687"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1063 22.0899V20.0809L16.0086 20.2316C16.3941 20.2959 16.789 20.2755 17.1658 20.1718C17.5426 20.0681 17.8923 19.8835 18.1905 19.6309C18.4887 19.3784 18.7284 19.0638 18.8927 18.7093C19.0571 18.3547 19.1423 17.9686 19.1423 17.5777V15.3723L19.9808 15.1634C20.1901 15.1111 20.3837 15.0093 20.5453 14.8665C20.7069 14.7237 20.8319 14.5442 20.9096 14.343C20.9873 14.1419 21.0156 13.925 20.9919 13.7106C20.9682 13.4962 20.8934 13.2907 20.7737 13.1113L19.1423 10.6638V9.99111C19.1423 6.81529 16.57 4.15248 13.0884 3.44395"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHeadphonesHead.displayName = 'SvgHeadphonesHead';
export default SvgHeadphonesHead;
